import UserTable from 'components/commonTable/UserTable';
import UserForm from 'components/forms/UserForm';
import React, { useEffect, useState } from 'react';
import { UserDto, UserInfoDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';

const SettingsPage = () => {
  const { uiStore } = useStoreWrapper();

  const [users, setUsers] = useState<UserInfoDto[]>([]);

  const fetchUsers = () => {
    ServiceHelper.userService.getUsers({ size: 100 }).then((res) => {
      setUsers(res.data);
    });
  };
  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRowClick = (user: UserInfoDto) => {
    uiStore?.modal.show({
      title: '사용자 정보',
      style: {
        width: '500px',
        height: 'auto',
        maxHeight: '500px',
      },
      children: (
        <div style={{ marginBottom: 20 }}>
          <UserForm user={user} />
        </div>
      ),
      onClose: () => {
        fetchUsers();
      },
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>사용자 설정</h1>
      <UserTable users={users} handleRowClick={handleRowClick} />
    </div>
  );
};

export default SettingsPage;
